import { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.mjs";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = ({ pdfUrl }) => {
  const [numPages, setNumPages] = useState(0);
  const [pdfDocument, setPdfDocument] = useState(null);
  const containerRef = useRef();

  useEffect(() => {
    const loadPdf = async () => {
      const loadingTask = pdfjs.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      setNumPages(pdf.numPages);
      setPdfDocument(pdf);
    };

    loadPdf();
  }, [pdfUrl]);

  useEffect(() => {
    const renderPages = async () => {
      if (!pdfDocument || !containerRef.current) return;

      const container = containerRef.current;
      container.innerHTML = "";

      const A4_WIDTH = 595.28; 
      const A4_HEIGHT = 841.89;

      for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
        const page = await pdfDocument.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1 });

        // Calculate scale to fit A4 size
        const scale = Math.min(
          A4_WIDTH / viewport.width,
          A4_HEIGHT / viewport.height
        );
        const scaledViewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = scaledViewport.height;
        canvas.width = scaledViewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: scaledViewport,
        };

        await page.render(renderContext).promise;
        container.appendChild(canvas);
      }
    };

    renderPages();
  }, [pdfDocument, numPages]);

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        border: "1px solid #ccc",
        padding: "10px",
        backgroundColor: "#fff",
      }}
    />
  );
};

export default PdfViewer;
